import React from 'react'
import styled from 'styled-components'
import { AddCardModalText } from 'src/components/Global/Text/TitleText'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const PermissionWrapper = styled.div`
  padding-top: 40px;
  margin-bottom: 40px;
  text-align: center;
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  }
  .confirm {
    margin: 40px 0px;
  }
`
const Permission = () => {
  let location = useLocation()
  return (
    <PermissionWrapper>
      <AddCardModalText className="wallet">Permission</AddCardModalText>
      <p className="choose">
        We would deduct a refundable amount of N10 to verify your card{' '}
      </p>
      <div>
        <Link
          to={`/big/card-successfull`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="confirm">Verify</ModalButton>
        </Link>
        <Link to={`/failure`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">Cancel</ModalButton>
        </Link>
      </div>
    </PermissionWrapper>
  )
}
const Confirmation = () => {
  let location = useLocation()
  return (
    <PermissionWrapper>
      <AddCardModalText className="wallet">Confirmation</AddCardModalText>
      <p className="choose">
        We are about to complete your request and debit your account of the sum
        of N5,000 to Joseph Chimezie. Please confirm this transaction.{' '}
      </p>
      <div>
        <Link
          to={`/transfer-successFull`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="confirm">Confirm</ModalButton>
        </Link>
        <Link to={`/failure`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">Cancel</ModalButton>
        </Link>
      </div>
    </PermissionWrapper>
  )
}
const InvestmentConfirmation = () => {
  let location = useLocation()
  return (
    <PermissionWrapper>
      <AddCardModalText className="wallet">Confirmation</AddCardModalText>
      <p className="choose">
        We are about to complete your request and debit your account of the sum
        of N50,000. Please confirm this transaction.
      </p>
      <div>
        <Link
          to={`/big/investment-successFull`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="confirm">Confirm</ModalButton>
        </Link>
        <Link to={`/big/failure`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">Cancel</ModalButton>
        </Link>
      </div>
    </PermissionWrapper>
  )
}
const AutomateSavingsConfirmation = () => {
  let location = useLocation()
  return (
    <PermissionWrapper>
      <AddCardModalText className="wallet">Confirmation</AddCardModalText>
      <p className="choose">Do you want to automate your savings?</p>
      <div>
        <Link
          to={`/big/collabo-successfull`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="confirm">Yes</ModalButton>
        </Link>
        <Link to={`/big/failure`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">No</ModalButton>
        </Link>
      </div>
    </PermissionWrapper>
  )
}

export {
  Permission,
  Confirmation,
  InvestmentConfirmation,
  AutomateSavingsConfirmation,
}
